var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import { Col } from "react-bootstrap";
import styled from "styled-components";
import { getActiveProducts } from "@irati/products/utils/products";
import { H3 } from "@irati/ui/src/Typography";
import FormattedMessage from "@irati/utils/lang";
import idHelper from "@irati/utils/id";
import { SectionHeader } from "../styled";
import HomePageRow from "../HomePageRow";
import { HomePageView } from "../types";
import ProductTile from "./Product";
var Overlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  opacity: 0.6;\n  width: 100vw;\n  height: ", ";\n  position: absolute;\n  left: 50%;\n  right: 50%;\n  top: ", ";\n  margin-left: -50vw;\n  margin-right: -50vw;\n"], ["\n  background-color: ", ";\n  opacity: 0.6;\n  width: 100vw;\n  height: ", ";\n  position: absolute;\n  left: 50%;\n  right: 50%;\n  top: ", ";\n  margin-left: -50vw;\n  margin-right: -50vw;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.dark;
}, function (_a) {
    var alignOverlayToBottom = _a.alignOverlayToBottom;
    return (alignOverlayToBottom ? "100%" : "150%");
}, function (_a) {
    var alignOverlayToBottom = _a.alignOverlayToBottom;
    return (alignOverlayToBottom ? "0" : "-50%");
});
var TenantProducts = function (props) {
    var pageView = props.pageView, alignOverlayToBottom = props.alignOverlayToBottom;
    var id = idHelper("tenant-products", props);
    var activeProducts = getActiveProducts();
    return (React.createElement(HomePageRow, { id: id },
        React.createElement(Col, { xs: 12 },
            React.createElement(SectionHeader, null,
                React.createElement(H3, null,
                    React.createElement(FormattedMessage, { id: "platform.homepage.products.title" }))),
            React.createElement("div", null, activeProducts.map(function (product, i) { return (React.createElement(ProductTile, { id: id, key: product.product, product: product, isLast: i === activeProducts.length - 1 })); }))),
        pageView === HomePageView.EDIT_CONTENT_VIEW && React.createElement(Overlay, { alignOverlayToBottom: alignOverlayToBottom })));
};
export default TenantProducts;
var templateObject_1;
